module.exports = __webpack_public_path__ + "r-v3/img/profile.62174f6c.svg";